import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestModel } from '../typings/typing';

@Injectable({
  providedIn: 'root',
})
export class WarrantyService {
  prefix = '/dealer_portal/warranty/dashboard';

  constructor(private http: HttpClient) {}

  /** 质保看板汇总 — 索赔总额、索赔总数、Turnover、赔付金额占比 */
  apiSummary(params: { startDate: string; endDate: string }) {
    return this.http.post<RequestModel>(this.prefix + '/summary', params);
  }

  /** 月度索赔总览 */
  apiMonthlyOverview(params: { startDate: string; endDate: string }) {
    return this.http.post<RequestModel>(this.prefix + '/monthly-overview', params);
  }

  /** 索赔金额和比例分析 */
  apiProductCategoryAnalysis(params: { startDate: string; endDate: string }) {
    return this.http.post<RequestModel>(this.prefix + '/product-category-analysis', params);
  }

  /** 质保申请明细分页查询 */
  apiApplicationDetailPage(body: {
    current: number;
    size: number;
    param?: { startDate?: string; endDate?: string; claimNo?: string; status?: string; boschMaterialNo?: string };
  }) {
    return this.http.post<RequestModel>('/dealer_portal/warranty/application/detail/page', body);
  }

  /** 信息速递分页查询 */
  apiNewsPage(body: {
    current: number;
    size: number;
    channelList: string[];
    isAdmin: boolean;
  }) {
    return this.http.post<RequestModel>('/userCenterAdmin/pages/page', body);
  }
}
